import { connect } from 'react-redux';
import { compose, withState, withHandlers, lifecycle } from 'recompose';
import { sendGoal } from '../../store/reducers/user-attributes/actions';
import { getNextActivity } from '../../store/reducers/digital-coach';
import { calculateMyPlan } from '../../helpers/my-plan';
import { withWidgetConfigData } from '../../helpers/hocs/with-widget-config-data';
import { withLoader } from '../../components/template';
import { withLoadingHandlers } from '../../components/with-loader';
import { MyPlan } from './component';

const mapStateToProps = state => ({ goals: state.userAttributes.goal });

export const MyPlanContainer = compose(
  connect(mapStateToProps, { sendGoal, getNextActivity }),
  withState('goalsState', 'setGoals', ({ goals }) => calculateMyPlan(goals)),
  withLoadingHandlers(true),
  withWidgetConfigData('MY_PLAN_WIDGET'),
  lifecycle({
    async componentDidMount() {
      const { goalsState, sendGoal, getNextActivity, turnOffLoading, fetchWidgetConfig } = this.props;
      await fetchWidgetConfig();

      sendGoal(goalsState, getNextActivity);
      turnOffLoading();
    }
  }),
  withHandlers({
    changeStateValue:
      ({ setGoals }) =>
      name =>
      value =>
        setGoals(goals => calculateMyPlan({ ...goals, [name]: value })),
    changeValueOnScrollEnd:
      ({ goalsState, sendGoal, getNextActivity }) =>
      () =>
      () =>
        sendGoal(goalsState, getNextActivity)
  }),
  withLoader
);

export const MyPlanWidget = MyPlanContainer(MyPlan);
